import React from 'react';
import PropTypes from 'prop-types';
import { Link, Card, TimeWithTimeZone, Text, Gap } from '@common/components';
import { CandidateOfferCardItem } from '@applicant-flow/components';
import { buildDialogUrl } from '@common/services';

function Offer({ record }) {
  const offerPreviewDrawerUrl = buildDialogUrl('offer-preview-drawer', {
    props: { offerId: record.id },
  });

  return (
    <CandidateOfferCardItem>
      <Link to={offerPreviewDrawerUrl}>
        <Text bold color="elm">
          View Offer Letter
        </Text>
      </Link>
      <div>
        <TimeWithTimeZone date={record.createdAt} variant="short_format" />
      </div>
    </CandidateOfferCardItem>
  );
}

Offer.propTypes = {
  record: PropTypes.object,
  application: PropTypes.object,
};

export function Offers({ records }) {
  return (
    !!records?.length && (
      <Card title="Offers">
        <Gap vertical>
          {records.map((offer) => (
            <Offer key={offer.id} record={offer} />
          ))}
        </Gap>
      </Card>
    )
  );
}

Offers.propTypes = {
  application: PropTypes.object,
  records: PropTypes.array,
};
